import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=8431bbdc&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
import style0 from "./Videos.vue?vue&type=style&index=0&id=8431bbdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8431bbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8431bbdc')) {
      api.createRecord('8431bbdc', component.options)
    } else {
      api.reload('8431bbdc', component.options)
    }
    module.hot.accept("./Videos.vue?vue&type=template&id=8431bbdc&scoped=true", function () {
      api.rerender('8431bbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Videos.vue"
export default component.exports